import { render, staticRenderFns } from "./serversList.vue?vue&type=template&id=0eb5fe55&scoped=true"
import script from "./serversList.vue?vue&type=script&lang=js"
export * from "./serversList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb5fe55",
  null
  
)

export default component.exports